import React, { Component } from "react";
import { withRouterUtilities } from "../util/withRouterUtilities";
import CenteredPaper from "../layouts/CenteredPaper";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import ChoiceButtons from "../molecules/ChoiceButtons";
import Titles from "../molecules/Titles";
import UswfList from "../molecules/UswfList";
import ILearn from "../molecules/ILearn";

class RefinancePrimaryReasonPage extends Component {
  render() {
    const content = contentMap.RefinancePrimaryReasonPage;
    const navigationsAway = customNavigationMap.RefinancePrimaryReasonPage;

    const rearrangedContent = {
      ...content,
      secondChoice: content.seventhChoice,
      seventhChoice: content.secondChoice,
    };
    return (
      <div className="page-wrapper">
        <ILearn content={content}>
          <CenteredPaper>
            <Titles content={rearrangedContent} />
            <UswfList content={rearrangedContent} />
            <ChoiceButtons
              content={rearrangedContent}
              navigationsAway={navigationsAway}
              navigate={this.props.navigate}
            />
          </CenteredPaper>
        </ILearn>
      </div>
    );
  }
}

export default withRouterUtilities(RefinancePrimaryReasonPage);
